export default __webpack_public_path__ + "static/media/SourceSerifPro-LightItalic.3747e1d8.ttf";